import { render, staticRenderFns } from "./addYuyue.vue?vue&type=template&id=501f9b21&scoped=true&"
import script from "./addYuyue.vue?vue&type=script&lang=js&"
export * from "./addYuyue.vue?vue&type=script&lang=js&"
import style0 from "./addYuyue.vue?vue&type=style&index=0&id=501f9b21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f9b21",
  null
  
)

export default component.exports